import { useEffect, useState } from 'react';

import loadFontOperation from 'editor/src/store/fonts/operation/loadFontOperation';
import getFontDefinition from 'editor/src/store/fonts/selector/getFontDefinition';
import isFontLoaded from 'editor/src/store/fonts/selector/isFontLoaded';
import { FontStatus } from 'editor/src/store/fonts/types';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

import useFabricCanvas from 'editor/src/util/useFabricCanvas';

function useFontLoader(fontFamily: string) {
  const fabricCanvas = useFabricCanvas();
  const dispatch = useDispatch();
  const fontLoaded = useSelector((state) => isFontLoaded(state, fontFamily));
  const fontFailed = useSelector((state) => getFontDefinition(state, fontFamily)?.status === FontStatus.failed);
  const defaultFontFamily = useSelector((state) => state.fonts.defaultFontStyles.fontFamily);
  const fallbackLoaded = useSelector((state) => isFontLoaded(state, defaultFontFamily));
  const [loadedFontFamily, setLoadedFontFamily] = useState(fontFamily);

  useEffect(() => {
    if (fontLoaded) {
      setLoadedFontFamily(fontFamily);
      fabricCanvas.requestRenderAll();
    } else if (fontFailed && fallbackLoaded) {
      setLoadedFontFamily(defaultFontFamily);
      fabricCanvas.requestRenderAll();
    } else if (!fontLoaded && !fontFailed) {
      void dispatch(loadFontOperation(fontFamily));
    }
  }, [fontLoaded, fontFailed, fallbackLoaded, fontFamily]);

  return {
    loadedFontFamily,
    isFontLoaded: fontLoaded || (fontFailed && fallbackLoaded),
  };
}

export default useFontLoader;
